import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';

const ModalEnvioEmail = ({ show, onHide, onConfirm, emailInicial = '', loading = false }) => {
  const [email, setEmail] = useState(emailInicial);
  const [emailValido, setEmailValido] = useState(false);

  useEffect(() => {
    setEmail(emailInicial);
  }, [emailInicial]);

  useEffect(() => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailValido(regex.test(email));
  }, [email]);

  const handleConfirm = () => {
    if (emailValido && !loading) {
      onConfirm(email);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Enviar Propuesta</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Correo electrónico del destinatario</Form.Label>
          <Form.Control
            type="email"
            placeholder="ejemplo@correo.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            isInvalid={email.length > 0 && !emailValido}
          />
          <Form.Control.Feedback type="invalid">
            Ingrese un correo electrónico válido
          </Form.Control.Feedback>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleConfirm}
          disabled={loading || !emailValido}
        >
          {loading ? <><Spinner size="sm" animation="border" /> Enviando...</> : 'Enviar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalEnvioEmail;
